
import {message, Modal} from "ant-design-vue";
import {Options, setup, Vue} from 'vue-class-component';
import IndicatorBox from "@/components/IndicatorBox/IndicatorBox.vue";
import {computed, createVNode, onMounted, reactive, ref, toRaw,toRefs} from "vue";
import InfoWrapper from "@/components/InfoWrapper.vue";
import FilterSearch from "@/components/table/FilterSearch.vue";
import {
  ExclamationCircleOutlined,
  QuestionCircleOutlined,
  MinusCircleOutlined,
  PlusOutlined
} from "@ant-design/icons-vue";
import MessageService from "@/utils/message";
import {useRouter} from "vue-router";
import convertUtils from "@/utils/convertUtils";
import FormUtils from "@/utils/formUtils";
import moment from "moment";
import customerService from "@/api/customerService";
import BottomToolBarV2 from "@/components/BottomToolBarV2.vue";
import EditOrAddModal from "@/components/basic/EditOrAddModal.vue";
import smsMessageService from "@/api/smsMessageService";
import SmsDetailModal from "@/views/Information/template/SmsDetailModal.vue";
import { useStore } from "vuex";
import BottomToolBar from "@/components/BottomToolBar.vue";
import dateUtils from "@/utils/dateUtils";
let context: any;
let parkInfo:any;

@Options({
  name: 'sms-template',
  components: {
    SmsDetailModal,
    EditOrAddModal,
    BottomToolBarV2,
    BottomToolBar,
    FilterSearch,
    InfoWrapper,
    IndicatorBox,
    MinusCircleOutlined,
    PlusOutlined
  },
})

export default class SmsTemplate extends Vue {
  created() {
    context = this;
  }

  tableInfo = setup(() => {
    //文件地址前缀
    const docPrefix = process.env.VUE_APP_API_DOC_NGINX_URL;
    //获取园区parkId
    // const parkId: number = convertUtils.getParkId();
    const store = useStore();
    const {currentParkInfo} = toRefs(store.state);
    parkInfo = currentParkInfo.value;

    //表格定义
    const sortedInfo = ref();
    const columns = computed(() => {
      const sorted = sortedInfo.value || {};
      return [
        {
          title: '名称',
          dataIndex: 'name',
          key: "name",
          fixed: 'left',
          width: 200
        },
        {
          title: '编码',
          dataIndex: 'code',
          key: "code",
        },

        {
          title: '模板内容',
          dataIndex: 'template',
          key: 'template',
        },
        {
          title: '签名',
          dataIndex: 'signName',
          key: "signName",
        },
        {
          dataIndex: "crtUser",
          key: "crtUser",
          width: 160,
          title: "创建人",
          slots: {
            customRender: 'crtUser'
          }
        },
        {
          dataIndex: "crtDate",
          key: "crtDate",
          width: 160,
          title: "创建时间",
          sorter: (a: any, b: any) => a.crtDate.length - b.crtDate.length,
          sortOrder: sorted.columnKey === 'crtDate' && sorted.order,
          slots: {
            customRender: 'crtDate'
          }
        },
        {
          title: '操作',
          dataIndex: 'ope',
          key: 'ope',
          fixed: 'right',
          width: 200,
          slots: {
            customRender: 'ope'
          }
        },
      ]
    });
    const paginationConfig = computed(() => {
      return {
        total: pageInfo.total,
        "show-size-changer": true,
        "show-total": (total: number) => `模板总计共${total} 条`,
        current: pageInfo.page,
        pageSize: pageInfo.size,
        "show-quick-jumper": true,
        pageSizeOptions: ['40', '60', '80']
      };
    });
    const metadata = reactive<Array<any>>([]);
    const data:any[] = reactive([

    ]);
    //搜索框定义
    const rows = reactive({
      name: {
        name: "模板名称",
        type: "text",
        defaultValue: null,
        clearable: true,
        disable: false,
        width: 200,
      },
      code:{
        name: "编码",
        type: "text",
        defaultValue: null,
        clearable: true,
        disable: false,
        width: 160,
      },
      signName:{
        name: "签名",
        type: "text",
        defaultValue: null,
        clearable: true,
        disable: false,
        width: 160,
      },
      startTime: {
        name: "开始时间",
        type: "date",
        defaultValue: null,
        clearable: true,
        disable: false,
        width: 160,

      },
      endTime: {
        name: "结束时间",
        type: "date",
        defaultValue: null,
        clearable: true,
        disable: false,
        width: 160,
      },
    });
    const rules = reactive({
      name: [
        {required: false, message: "请输入服务机构名称", trigger: "blur"},
      ],
      beginTime: [
        {required: false, message: "请选择开始时间", trigger: "change"},
      ],
      endTime: [
        {required: false, message: "请选择结束始时间", trigger: "change"},
      ],

    });
    let isHas = ref(true);
    //多选
    const state = reactive<any>({
      selectedRowKeys: [],
      totalData: [],
      selectedRows: []
    });
    const bottomToolBarButtonList = computed(() => {
      return [
        // {
        //   title: "批量导出",
        //   callback: excelOut

        // },
        {
          title: "批量删除",
          callback: () => {
            deleteMultipleData();
          },

        },
      ];
    });
    //搜索请求参数
    const pageInfo = reactive<any>({
      total: 0,
      size: 40,
      page: 1,
    });
    const reqParams = reactive<any>({
      declareName: "",
      beginTime: null,
      endTime: null,
      type: null,
      switchStatus: null,
    });
    //初始化
    const initData = () => {
      loadData();
    };
    onMounted(initData);
    //表格数据
    const loadData = () => {

      const params = getRequestParams();  
      smsMessageService.getSmsMessageTypePageListByParams(params).then((result: any) => {
        if (result.status !== 200) {
          return;
        }
        const info = result.data;
        var list:any[] = info.rows;
        data.splice(0,data.length,...list);

      })

    };
    const convertInfo = (info: any) => {

      let declareTypeName = convertUtils.getDeclareTypeName(info.type);
      Reflect.set(info, "declareTypeName", declareTypeName);
      let declareStatusName = convertUtils.getDeclareStatusName(info.switchStatus);
      Reflect.set(info, "declareStatusName", declareStatusName);


      return FormUtils.setUndefinedColumnToRailAndColumns(info, columns.value);
    };
    const getRequestParams = () => {

      let params: any = {
        scopeId: parkInfo.id,
      };

      Object.assign(params, pageInfo, reqParams)
      ////console.log('完整请求参数：', params)
      return params;
    };
    //指标
    //TODO 模板指标接口，缺少
    // const initDayCountList = () => {
    //   // let list: any = [];
    //   smsMessageService.getSmsMessageTypeCountByScopeId(parkInfo.id).then(result => {
    //     if(result.status == 200){
    //       var data = result.data;
    //       indicatorDto.monthCount = data.monthNumber;
    //       indicatorDto.weekCount = data.weekNumber;
    //       indicatorDto.todayCount = data.todayNumber;
    //     }
       
    //   });
    // };
    //搜索栏
    const resetParams = () => {
      for (let key in reqParams) {
        reqParams[key] = null;
      }
    };
    //TODO 测试筛选
    const updateReqParams = (params: any) => {
      for (let key in params) {
        reqParams[key] = params[key];
        if (key === 'name') {
          reqParams.declareName = params.name
        }
      }
    };
    const search = () => {
      resetState();
      pageInfo.page = 1;
      loadData();
    };
    const research = () => {
      resetParams()
      search();
    };
    //分页数据
    const handleChange = (pagination: any, filter: any, sorter: any) => {
      pageInfo.page = pagination.current;
      pageInfo.size = pagination.pageSize;
      sortedInfo.value = sorter;
      loadData();
    };
    const onSelectChange = (selectedRowKeys: any[], selectedRows: any[]) => {
      state.selectedRowKeys = selectedRowKeys;
      state.selectedRows = selectedRows;
    };
    //多选栏
    const resetState = () => {
      for (let key in state) {
        state[key] = [];
      }
    };
    const selectAll = (data: any) => {
      if (!data.hasRequested) {
        smsMessageService.getSmsMessageTypePageListByParams(data.params).then((result: any) => {
          if (result.status !== 200) {
            return;
          }
          const info = result.data;
          pageInfo.total = info.total;
          // 缓存数据
          info.rows.forEach((el: any) => {
            state.totalData.push(el);
          })
          console.log('p state', state);
          state.totalData.forEach((el: any) => {
            state.selectedRowKeys.push(el.id);
          });
        });
      }
    };
    //批量操作
    //TODO 批量导出，缺少接口
    const excelOut = () => {
      Modal.confirm({
        title: () => "确认导出",
        icon: () => createVNode(QuestionCircleOutlined),
        content: () => "确认要导出Excel文件？",
        okText: () => "确定",
        onOk() {
          let day = moment(new Date()).utcOffset(480).format("YYYY-MM-DD");
          let fileName = "模板信息" + day + ".xlsx";
          let params = {
            excelHeaderTitle: "模板信息",
            scopeId: parkInfo.id,
            clientIds: state.selectedRowKeys.join()
          };
          // customerService.getPotentialClientsExcelFile(params).then((result: any) => {
          //   let blob = result;
          //   blob = new Blob([blob], {
          //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          //   });
          //   let objectUrl = URL.createObjectURL(blob);
          //   let a = document.createElement("a");
          //   document.body.appendChild(a);
          //   a.setAttribute("style", "display:none");
          //   a.download = fileName;
          //   a.href = objectUrl;
          //   a.click();
          // });
        },
        onCancel() {
          ////console.log("Cancel");
        },
        class: "test",
      });
    };
    //TODO 批量删除，缺少
    const deleteMultipleData = () => {
      Modal.confirm({
        title: () => "是否要批量删除?",
        icon: () => createVNode(ExclamationCircleOutlined),
        content: () => `是否要批量删除，数据删除后无法恢复，请慎重考虑是否删除！`,
        okText: () => "删除",
        okType: "danger",
        cancelText: () => "取消",
        onOk() {
          let ids = state.selectedRowKeys.join();
          // let ids: string = data.map((el: any) => el.id).join();
          smsMessageService.batchDeleteSmsMessageType(ids).then(result => {
            if (result.status !== 200) {
              return;
            }
            MessageService.success("删除成功！");
            research();
          })
        },
        onCancel() {
        },
      });
    };

    const cancelSelect = (data: any) => {
      console.log('cancelSelect', data);
      state.selectedRowKeys = data;
    };

     const checkedList = ref<any>([]);
    
    const buttonClick = (data: any) => {
      checkedList.value.splice(0, checkedList.value.length, ...data);
    };

    return {
      data,
      columns,
      rows,
      rules,
      isHas,
      paginationConfig,
      docPrefix,
      // func
      handleChange,
      search,
      updateReqParams,
      research,
      excelOut,
      loadData,
      //bottomTool
      bottomToolBarButtonList,
      pageInfo,
      state,
      onSelectChange,
      selectAll,
      getRequestParams,
      ...toRefs(pageInfo),
      //这里必须用到两个state，否则就会报错，目前还不清楚原因
      ...toRefs(state),
      cancelSelect,
      buttonClick,
      checkedList,
    }
  });

  opeInfo = setup(() => {
    const router = useRouter();
    const dataList = reactive<any[]>([]);
    const recordData = reactive<any>({});
    const opeModalShowInfo = reactive({
      createOrEditShow: false,
      detailShow: false
    })

    const showDetailModal = (record: any) => {
      FormUtils.clearObject(recordData);
      Object.assign(recordData, record);
      recordData.obj = JSON.parse(recordData.itemContent);
      //必须要初始化，否则是undefined
      recordData.itemList = [];
      let obj = recordData.obj;
      //console.log(recordData)
      for (const objKey in obj) {
        recordData.itemList.push({
          key: objKey.toString(),
          value: `${obj[objKey]}`
        })
      }
      opeModalShowInfo.detailShow = true;
    }

    const showTaskDetail = (data: any) => {
      router.push({
        name: "declare-detail",
        params: {declareId: data.id}
      });
    };
    //TODO 删除接口
    const showDeleteDialog = (data: any) => {
      Modal.confirm({
        title: () => '确定要删除么',
        icon: () => createVNode(QuestionCircleOutlined),
        content: () => '删除后将无法恢复，请慎重考虑是否删除！',
        okText: () => '删除',
        onOk() {

          smsMessageService.removeSmsMessageTypeById(data.id).then((result: any) => {
            if (result.status !== 200) {
              return;
            }
            context.tableInfo.research();
            context.tableInfo.initIndicatorData();
            MessageService.info("删除成功！");
          })
        },
        onCancel() {
        },
        class: "test",
      });
    };


    return {
      opeModalShowInfo,
      dataList,
      recordData,
      showDetailModal,
      //  删除
      showDeleteDialog,
      //详情
      showTaskDetail
    }
  });

  editInfo = setup(() => {
    const modalConfig = reactive({
      visible: false,
      editFlag: false,
      modalName: "短信模板",
      width: 600,
    });
    const parkId = convertUtils.getParkId();
    const formData = reactive<any>({
      id: null,
      name: '',
      code: '',
      template: '',
      itemList: [{key: '', value: ''}],
      itemContent: {},
      obj: {},
      signName:'',
    });
    const rules = reactive({
      name: [
        {required: true, message: '请输入模板名称', trigger: 'blur'}
      ],
      code: [
        {required: true, type: 'string', message: '请输入模板代码', trigger: 'blur'}
      ],
      template: [
        {required: true, message: '请输入模板内容', trigger: 'blur'},
      ],
      signName: [
        {required: true, message: '请输入签名', trigger: 'blur'},
      ],
    });
    let validateForm: any;

    const setValidateForm = (e: any) => {
      validateForm = e;
    }
    const showEditModal = (record: any) => {
      FormUtils.setFormByRecord(record, formData);
      formData.obj = JSON.parse(formData.itemContent);
      //必须要初始化，否则是undefined
      formData.itemList = [];
      // let obj: any = formData.obj;
      for (const objKey in formData.obj) {
        formData.itemList.push({
          key: `${objKey}`,
          value: `${formData.obj[objKey]}`
        })
      }
      modalConfig.editFlag = true;
      modalConfig.visible = true;
      modalConfig.modalName = '编辑短信模板';
    };
    const showCreateModal = () => {
      formData.itemList = [{value: '', key: ''}];
      formData.itemContent = {}

      modalConfig.editFlag = false;
      modalConfig.visible = true;
      modalConfig.modalName = '添加短信模板';

    };
    const cancel = () => {
      if (validateForm) {
        validateForm.resetFields();
      }
      FormUtils.clearForm(formData)
      modalConfig.visible = false;
    };
    const closeModalAndRefreshTable = () => {

      cancel();
      context.tableInfo.research();
      context.tableInfo.initIndicatorData();
    };
    const confirm = () => {
      validateForm.validate().then(() => {
        let info: any = toRaw(formData);
        info.scopeId = parkId;
        info.itemContent = {};
        info.itemList.map((el: any) => {
          let value = el.value;
          let key = el.key;
          Reflect.set(info.itemContent, `${key}`, value);
        })
        info.itemContent = JSON.stringify(info.itemContent)
        console.log('info', info)
 
        if (modalConfig.editFlag) {
          smsMessageService.updateSmsMessageType(info).then(() => {
            MessageService.info('保存成功！');
            closeModalAndRefreshTable();
          })
        } else {
          smsMessageService.createSmsMessageType(info).then(() => {
            MessageService.info('新增成功！');
            closeModalAndRefreshTable();
          })
        }
      }).catch((error: any) => {
        //console.log('err', error)
      })
    };
    //动态增减表单
    const removeItem = (item: any) => {
      //console.log('item', item)
      let index = formData.itemList.indexOf(item);
      if (index !== -1) {
        formData.itemList.splice(index, 1);
      }
    }
    const addItem = () => {
      formData.itemList.push({key: '', value: ''})
      // //console.log('list', formData.itemList)
    }

    return {
      modalConfig,
      formData,
      rules,
      showCreateModal,
      showEditModal,
      cancel,
      confirm,
      removeItem,
      addItem,
      setValidateForm
    }
  });
}


